import { getConfig } from '@sortlist-frontend/config';
import { ImageSourceHelper } from '@sortlist-frontend/media';
import { Trans, useTranslation } from '@sortlist-frontend/translation/ssr';
import Image from 'next/image';

export default function FoundersNotes() {
  const { publicEnv } = getConfig();
  const { t } = useTranslation();

  return (
    <div className="container-lg layout-column layout-align-start-center py-24">
      <h3 className="h1-gt-xs h3-xs text-center text-secondary-900 bold">{t('about:founders.title')}</h3>
      <Image
        alt={t('about:founders.imageAlt')}
        src={ImageSourceHelper.fromUrl(`${publicEnv.s3Bucket}/illustrations/about/team/founders.webp`)}
        width={1120}
        height={504}
        sizes="100vw"
        style={{
          width: '100%',
          height: 'auto',
        }}
        className="rounded-xl mt-16"
        quality={100}
      />
      <div className="mt-14 text-left text-secondary-700">
        <Trans i18nKey="about:founders.content" components={{ p: <p className="h6 lh-3 mb-6" /> }} />
        <p className="h6 lh-3 bold">{t('about:founders.signature')}</p>
      </div>
    </div>
  );
}
